import React from 'react'
import { rubricPersistActions } from '../../../../../../../store/slices/rubric.persist.slice'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import MatchingForm from '../common/matching-form/MatchingForm'

const QuestionMatchingForm = ({ originalQuestions, rubricQuestions }) => {
    const dispatch = useDispatch()
    const { token } = useParams()

    const handleSubmit = ({ originalItems, matchedItems }) => {
        dispatch(
            rubricPersistActions.mergeQuestions({
                token,
                questions: originalItems.map(q => ({
                    ...q,
                    id: Number(q.id),
                })),
                rubricQuestions: matchedItems,
            }),
        )
        dispatch(rubricPersistActions.nextStep({ token }))
    }

    return (
        <MatchingForm
            originalItems={originalQuestions}
            matchedItems={rubricQuestions}
            renderItem={question => question.name || question.content}
            matchingProperty='matchingQuestionId'
            onSubmit={handleSubmit}
            titleLeft='Original Questions'
            titleRight='Rubric Questions'
            submitButtonText='Save & Next'
        />
    )
}

export default QuestionMatchingForm
